import React, { useEffect } from "react";
import "../component/ProjectV2item.css";
import ui from "../images/ui.jpg";
import institude from "../images/responsive image/insttituse/ipc.png";
import news from "../images/responsive image/news/npc.png";
function ProjectV2item(props) {
  useEffect(() => {
    document.title = "Pijush Ray Mondal || Project";
    // project description
    const hiddenElement = document.querySelectorAll(".hiddenProject");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        // console.log(e);
        if (e.isIntersecting) {
          e.target.classList.add("show");
        } else {
          e.target.classList.remove("show");
        }
      });
    });

    hiddenElement.forEach((el) => {
      observer.observe(el);
      // console.log(el);
    });

    // project title
    const hiddenTitle = document.querySelectorAll(".hiddenTitle");
    const observerTitle = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        // console.log(e);
        if (e.isIntersecting) {
          e.target.classList.add("showTitle");
        } else {
          e.target.classList.remove("showTitle");
        }
      });
    });

    hiddenTitle.forEach((el) => {
      observerTitle.observe(el);
    });
  }, []);
  return (
    <div className="project-body">
      {/* project-1 */}
      <div className="project-self">
        <div className="project-details">
          <p className="project-type">PERSONAL PROJECT </p>
          <p className="project-title hiddenTitle">
            Beginner Designers landpage
            <sup></sup>
          </p>
          <div className="project-tools">
            <span>React</span>
            <span>netlify</span>
            <span>github</span>
            <span>vs code</span>
            <span>Metarial ui</span>
            <span>React router</span>
          </div>

          <div className="project-description hiddenProject">
            A pixel-perfect responsive lendpage design. Coded using flexbox and
            gid
          </div>
          <div className="project-button">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://neon-profiterole-7260d4.netlify.app/"
            >
              <button className="project-live">
                View project &nbsp;
                <span>
                  <i class="fas fa-external-link-alt"></i>
                </span>
              </button>
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://github.com/PIJUSH364/desiner/tree/main/build"
            >
              <button className="project-code">
                Source code&nbsp;
                <span>
                  <i class="fa-brands fa-github"></i>
                </span>
              </button>
            </a>
          </div>
        </div>
        <div className="project-overviewImg">
          <figure>
            <a
              rel="noreferrer"
              href="https://neon-profiterole-7260d4.netlify.app/"
              target="_blank"
            >
              {" "}
              <img src={ui} alt="ui" />
            </a>
          </figure>
        </div>
      </div>
      {/* project-2 */}
      <div className="project-self">
        <div className="project-details">
          <p className="project-type">PERSONAL PROJECT </p>
          <p className="project-title hiddenTitle">
            News Application
            <sup></sup>
          </p>
          <div className="project-tools">
            <span>React</span>
            <span>netlify</span>
            <span>github</span>
            <span>vs code</span>
            <span>Metarial ui</span>
            <span>React router</span>
            <span>Rest Api</span>
          </div>

          <div className="project-description hiddenProject">
            Used REST API that returns JSON search results for current and
            historic news articles published by over The worldwide sources.The
            Project is a NewsAPP which fetches NewsAPI and Shows the user Live
            News Articles.
          </div>
          <div className="project-button">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://vermillion-tarsier-6abf02.netlify.app/"
            >
              <button className="project-live">
                View project&nbsp;
                <span>
                  <i class="fas fa-external-link-alt"></i>
                </span>
              </button>
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://github.com/PIJUSH364/newsbuddy"
            >
              <button className="project-code">
                Source code&nbsp;
                <span>
                  <i class="fa-brands fa-github"></i>
                </span>
              </button>
            </a>
          </div>
        </div>
        <div className="project-overviewImg">
          <figure>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://vermillion-tarsier-6abf02.netlify.app/"
            >
              {" "}
              <img src={news} alt="ui" />
            </a>
          </figure>
        </div>
      </div>{" "}
      {/* project-3 */}
      <div className="project-self">
        <div className="project-details">
          <p className="project-type">PERSONAL PROJECT </p>
          <p className="project-title">
            Institution Landpage
            <sup></sup>
          </p>
          <div className="project-tools">
            {" "}
            <span>Font awesome</span>
            <span>netlify</span>
            <span>github</span>
            <span>vs code</span>
            <span>JavaScript</span>
          </div>

          <div className="project-description hiddenProject">
            Fully responsive web page that make user friendly to use and also
            student submit their query on this page
          </div>
          <div className="project-button">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://pijush364.github.io/School_project/"
            >
              <button className="project-live">
                View project&nbsp;
                <span>
                  <i class="fas fa-external-link-alt"></i>
                </span>
              </button>
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://github.com/PIJUSH364/Bele-Durganagar-High-School.github.io"
            >
              <button className="project-code">
                Source code&nbsp;
                <span>
                  <i class="fa-brands fa-github"></i>
                </span>
              </button>
            </a>
          </div>
        </div>
        <div className="project-overviewImg">
          <figure>
            <a
              href="https://pijush364.github.io/School_project/"
              rel="noreferrer"
              target="_blank"
            >
              {" "}
              <img src={institude} alt="ui" />
            </a>
          </figure>
        </div>
      </div>{" "}
      {/* project-4 */}
      <div className="project-self">
        <div className="project-details">
          <p className="project-type">PERSONAL PROJECT </p>
          <p className="project-title hiddenTitle">
            Amazone-clone
            <sup>Coming soon...</sup>
          </p>
          <div className="project-tools">
            <span>React</span>
            <span>netlify</span>
            <span>github</span>
            <span>vs code</span>
            <span>Metarial ui</span>
            <span>React router</span>
            <span>Firebase</span>
          </div>

          <div className="project-description hiddenProject">
            Hello folks 😃 , I made Amazon clone using #Reactjs. I have tried
            that it should have the functionality of Amazon as well as add some
            additional functionality to it. I have tried that its user interface
            is simple and beautiful.
          </div>
          <div className="project-button">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://musical-sorbet-eea5e7.netlify.app/"
            >
              <button className="project-live">
                View project&nbsp;
                <span>
                  <i class="fas fa-external-link-alt"></i>
                </span>
              </button>
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://github.com/PIJUSH364/Amazon-Application_"
            >
              <button className="project-code">
                Source code&nbsp;
                <span>
                  <i class="fa-brands fa-github"></i>
                </span>
              </button>
            </a>
          </div>
        </div>
        <div className="project-overviewImg">
          <figure>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://musical-sorbet-eea5e7.netlify.app/"
            >
              <img
                src="https://images.unsplash.com/photo-1632813405743-ab79b1d3d98b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=891&q=80"
                alt="ui"
              />
            </a>
          </figure>
        </div>
      </div>
    </div>
  );
}

export default ProjectV2item;
